// extracted by mini-css-extract-plugin
export default {"controls":"controls_controls__ST3zK","controls-buttons":"controls_controls-buttons__OaaxC"};